import { createSelector } from 'reselect'

import { Field } from 'common/filter/interfaces'

export const getFilterFields = (state: RootState) => state.filter.fields

export const getSystemFilterFields = createSelector(
  [getFilterFields],
  (filterFields): Field[] => filterFields.system || [],
)
